import React from "react";
import { v4 as uuidv4 } from "uuid";
import { withRouter } from "react-router-dom";
import SoilTestsDetails from "./SoilTestsDetails";

const SoilTestsCreate = (props) => {
    const soilTests = { id: uuidv4(), sType: "Organic", nutrients: {}, applications: [] };
    return <SoilTestsDetails {...props} soilTests={soilTests} />;
};

export default withRouter(SoilTestsCreate);
